import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveRoleMutation = gql`
   mutation SaveRole(
      $role: RoleInput!
      $rolePrivileges: [RolePrivilegeInput!]!
      $deletedRoleReportIds: [UInt!]!
      $deletedRolePrivilegeIds: [UInt!]!
      $deletedRoleCallRecordingExtensionIds: [UInt!]!
      $deletedRoleCallRecordingExtensionGroupIds: [UInt!]!
      $hasDeletedRoleReports: Boolean = false
      $hasDeletedRolePrivileges: Boolean = false
      $hasDeletedCallRecordingExtensions: Boolean = false
      $hasDeletedCallRecordingExtensionGroups: Boolean = false
   ) {
      deleteRoleReports(ids: $deletedRoleReportIds) @include(if: $hasDeletedRoleReports)
      deleteRolePrivileges(ids: $deletedRolePrivilegeIds) @include(if: $hasDeletedRolePrivileges)
      deleteRoleCallRecordingExtensions(ids: $deletedRoleCallRecordingExtensionIds)
         @include(if: $hasDeletedCallRecordingExtensions)
      deleteRoleCallRecordingExtensionGroups(ids: $deletedRoleCallRecordingExtensionGroupIds)
         @include(if: $hasDeletedCallRecordingExtensionGroups)
      role: saveRole(role: $role) {
         roleId
         name
         description
         roleReportsConnection {
            items {
               roleId
               reportId
            }
         }
         roleCallRecordingExtensionsConnection {
            items {
               roleCallRecordingExtensionId
               roleId
               extensionId
               isInclude
            }
         }
         roleCallRecordingExtensionGroupsConnection {
            items {
               roleCallRecordingExtensionGroupId
               roleId
               extensionGroupId
               isInclude
            }
         }
         hasAllExtensionRecordings
      }
      rolePrivileges: saveRolePrivileges(rolePrivileges: $rolePrivileges) {
         rolePrivilegeId
         privilegeId
         roleId
         accountId
         isAdd
         isView
         isEdit
         isDelete
         isEnabled
      }
   }
`;
